import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const Register = () => {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const r = await register(form.name, form.email, form.password);
    setLoading(false);
    if (r.ok) nav("/identify");
    else setError(r.error);
  };

  return (
    <div className="grid md:grid-cols-2 gap-10 items-stretch min-h-[70vh]">
      <form onSubmit={submit} className="panel p-8 md:p-10 flex flex-col justify-center" data-testid="register-form">
        <p className="font-mono text-xs tracking-widest text-amber-brass uppercase">// New Owner</p>
        <h1 className="font-display text-4xl uppercase text-cream mt-1 mb-8">Get Your Keys</h1>

        <label className="font-mono text-xs uppercase tracking-widest text-secondary">Name</label>
        <input data-testid="register-name" className="data-input mt-1 mb-5" required
          value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />

        <label className="font-mono text-xs uppercase tracking-widest text-secondary">Email</label>
        <input data-testid="register-email" className="data-input mt-1 mb-5" type="email" required
          value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />

        <label className="font-mono text-xs uppercase tracking-widest text-secondary">Password (min 6)</label>
        <input data-testid="register-password" className="data-input mt-1 mb-6" type="password" required minLength={6}
          value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />

        {error && (
          <div data-testid="register-error" className="mb-4 border border-[var(--accent-red)] bg-[rgba(217,32,39,0.1)] text-cream font-mono text-xs px-3 py-2">
            {error}
          </div>
        )}

        <button data-testid="register-submit" disabled={loading} className="chrome-btn w-full">
          {loading ? "Building profile…" : "Create Account"}
        </button>
        <p className="mt-6 text-sm text-secondary text-center">
          Already registered? <Link to="/login" data-testid="link-login" className="text-amber-brass underline">Sign in</Link>
        </p>
      </form>

      <div className="relative panel overflow-hidden hidden md:block">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: "url('https://images.pexels.com/photos/15469392/pexels-photo-15469392.jpeg')",
            backgroundSize: "cover", backgroundPosition: "center",
            filter: "grayscale(40%)",
          }}
        />
        <div className="absolute inset-0 bg-black/65" />
        <div className="relative z-10 p-10 h-full flex flex-col justify-end">
          <span className="tag-chip">Digital Title</span>
          <h2 className="font-display text-5xl uppercase text-cream mt-3 leading-none">Your<br />garage,<br /><span className="text-amber-brass">catalogued.</span></h2>
        </div>
      </div>
    </div>
  );
};

export default Register;
